import { ArrowDownLeft, ArrowUpRight, ShieldAlert } from "lucide-react";
import { inr } from "@/lib/api";

const META = [
  { key: "collection", label: "Collection Wallet", badge: "Incoming payments", icon: ArrowDownLeft, ring: "from-emerald-500/15", dot: "bg-emerald-500", txt: "text-emerald-600" },
  { key: "payout", label: "Payout Wallet", badge: "Available for payout", icon: ArrowUpRight, ring: "from-blue-500/15", dot: "bg-blue-600", txt: "text-blue-600" },
  { key: "chargeback", label: "Chargeback Wallet", badge: "Risk reserve", icon: ShieldAlert, ring: "from-amber-500/15", dot: "bg-amber-500", txt: "text-amber-600" },
];

export const WalletCards = ({ user }) => (
  <div className="grid gap-4 md:grid-cols-3">
    {META.map((w, i) => (
      <div
        key={w.key}
        data-testid={`wallet-${w.key}-card`}
        className={`rise d${i + 1} relative overflow-hidden rounded-xl border border-slate-200 bg-white p-5 transition-shadow hover:shadow-lg`}
      >
        <div className={`pointer-events-none absolute -right-10 -top-10 h-36 w-36 rounded-full bg-gradient-to-br ${w.ring} to-transparent`} />
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-slate-600">{w.label}</span>
          <span className={`grid h-9 w-9 place-items-center rounded-lg bg-slate-50 ${w.txt}`}>
            <w.icon className="h-4 w-4" />
          </span>
        </div>
        <div className="mt-4 font-display text-3xl font-bold tracking-tight text-[#0A1F44]" data-testid={`wallet-${w.key}-balance`}>
          {inr(user?.[`${w.key}_balance`])}
        </div>
        <div className="mt-3 flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-slate-500">
          <span className={`h-1.5 w-1.5 rounded-full ${w.dot}`} /> {w.badge}
        </div>
      </div>
    ))}
  </div>
);
